/**
 * The maximum number of columns that can be selected
 * in the Custom Columns page for user settings
 */
export const TOTAL_USER_COLUMNS = 30;
